export function imageFileDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string' && reader.result.startsWith('data:image/')) {
        resolve(reader.result);
      } else {
        reject(new Error('저장할 이미지를 준비하지 못했어요.'));
      }
    };
    reader.onerror = () => reject(reader.error ?? new Error('이미지를 읽지 못했어요.'));
    reader.onabort = () => reject(new Error('이미지 준비가 중단됐어요. 다시 시도해 주세요.'));
    reader.readAsDataURL(file);
  });
}

export function canShareFortuneImage(file: File): boolean {
  try {
    return typeof navigator.share === 'function'
      && typeof navigator.canShare === 'function'
      && navigator.canShare({ files: [file] });
  } catch {
    return false;
  }
}

export async function sharePreparedFortuneImage(file: File): Promise<'shared' | 'cancelled' | 'unavailable'> {
  if (!canShareFortuneImage(file)) return 'unavailable';
  try {
    // File-only sharing keeps iOS image actions available. No rendering,
    // FileReader, fetch, window.open, or await may precede this direct-tap call.
    await navigator.share({ files: [file] });
    return 'shared';
  } catch (error) {
    if (error && typeof error === 'object' && 'name' in error && error.name === 'AbortError') return 'cancelled';
    return 'unavailable';
  }
}
